module.exports = __webpack_public_path__ + "static/img/news_banner.1b81b23.1b81b23.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/news_banner.1b81b23.png
// module id = HHhr
// module chunks = 1